<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <svg-icon src="./assets/images/icons/close.svg"></svg-icon>
    </button>
</div>
<div class="modal-body text-center">
    <h4 class="font-weight-semibold mb-3 mb-md-4">Send Reminder</h4>
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()" class="text-left">
        <div class="form-group floating_form_field mb-0 w-100">
            <textarea formControlName="reminderMessage" id="reminderMessage" class="form-control"
                [(ngModel)]="pollsandsurvey.reminderMessage" placeholder="Reminder Note?" [readOnly]="isEditNote" required></textarea>
            <label>Reminder Note</label>
        </div>
        <div *ngIf="myForm.get('reminderMessage').invalid && myForm.get('reminderMessage').touched"
            class="small text-danger">
            <div *ngIf="myForm.get('reminderMessage').errors?.required">Reminder Note</div>
            <div *ngIf="myForm.get('reminderMessage').errors?.maxlength">The Reminder Note may not be longer than 500
                charecters</div>
        </div>
        <div class="d-flex align-items-center column-gap-3 mt-3 mt-md-4 mt-lg-5">
            <button class="btn btn-clear w-50" type="button" (click)="editNote()" *ngIf="pollsandsurvey.reminderMessage!=''">Edit Note</button>
            <button class="btn btn-primary w-50" type="submit">Send</button>
        </div>
    </form>
</div>